export default __webpack_public_path__ + "static/media/profile-placeholder.30a5b64a.png";